'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _FormattedCurrency = require('I18n/components/FormattedCurrency');

var _FormattedCurrency2 = _interopRequireDefault(_FormattedCurrency);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Helpful for currencies with large denominations (i.e. COP)
var ABBREVIATE_THRESHOLD = 9999999;
var MAX_FRACTION_DIGITS = 3;

var PriceDisplay = function PriceDisplay(_ref) {
  var className = _ref.className,
      currencyCode = _ref.currencyCode,
      price = _ref.price,
      _ref$dataSelenium = _ref.dataSelenium,
      dataSelenium = _ref$dataSelenium === undefined ? '' : _ref$dataSelenium;

  return _react2.default.createElement(
    'span',
    { className: className, 'data-selenium-id': dataSelenium },
    _react2.default.createElement(_FormattedCurrency2.default, {
      simplifyCurrency: true,
      value: Math.ceil(price),
      currencyCode: currencyCode,
      abbreviate: true,
      abbreviateThreshold: ABBREVIATE_THRESHOLD,
      maxFractionDigits: MAX_FRACTION_DIGITS,
      'data-jasmine': 'jasmine-price-display'
    })
  );
};

PriceDisplay.propTypes = {
  dataSelenium: _react.PropTypes.string,
  className: _react.PropTypes.string,
  currencyCode: _react.PropTypes.string.isRequired,
  price: _react.PropTypes.number
};

exports.default = PriceDisplay;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/common/pricing/PriceDisplay.js
// module id = 38
// module chunks = 3 4 5